import { ReactNode, useContext, useState } from 'react';
import { ThemeContext, ThemeConfig, ThemeContextValue } from '../context/ThemeContext';
import { ThemeColors } from 'src/constants/theme-colors';

const THEME_CONFIG: Record<string, ThemeConfig> = {
  green: {
    color: '#33FF71',
    colorFill: '#21C007',
    className: ThemeColors.green,
  },
  blue: {
    color: '#75F3FB',
    colorFill: '#75F3FB',
    className: ThemeColors.blue,
  },
  yellow: {
    color: '#E8FD65',
    colorFill: '#E8FD65',
    className: ThemeColors.yellow,
  },
  purple: {
    color: '#BDB4FD',
    colorFill: '#A498FF',
    textColorClassName: 'text-[#7A6BE5]',
    className: ThemeColors.purple,
  },
};

export function useTheme(): ThemeContextValue | null {
  return useContext(ThemeContext);
}

export function ThemeProvider({ children }: { children: ReactNode }) {
  const [theme, setTheme] = useState('green');

  const value: ThemeContextValue = {
    theme,
    setTheme,
    config: THEME_CONFIG[theme],
  };

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}
